import { WebsocketKey } from "../../../config/enum";
import { UITable } from "../../common/table";
import { socket } from "../../../redux/services/webSocket";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { selectCurrentAppState, setProcessStep, setInventoryError, setVerificationProgress, setUnexpectedTag, setVerificationResults } from "../../../redux/features/app/appSlice";
import { useEffect, useState, useRef } from "react";
import moment from "moment";
import UITooltip from "../../common/tooltip";

export const ActivityLogsTable = (props: any) => {
  const { logsTableData, tagsReadData, setLoadingBar } = props;

  const dispatch = useDispatch();
  const [tableData, setTableData] = useState<any>([]);
  const { inventoryError } = useSelector(selectCurrentAppState);
  const previousTableDataRef = useRef<any[]>([]); // Track previous table data to preserve on empty refetch

  useEffect(() => {
    console.log(tagsReadData, ">>>>>>>>>>>>>>>>...tags data")
    
    // Stop loading bar if there's an inventory error
    if (inventoryError) {
      setLoadingBar(false);
    }
    
    if(tagsReadData?.isSuccess){
      setLoadingBar(false)
      const payload: any = tagsReadData?.data;
      // Support multiple shapes: {result:{data:[]}}, {result:[]}, {data:[]}
      const rows: any[] = (payload?.result?.data) || (payload?.result) || (payload?.data) || [];
      const currentTableCount = previousTableDataRef.current.length;
      
      console.log('ActivityLogsTable: parsed rows from inventory payload', {
        hasResultData: Array.isArray(payload?.result?.data),
        hasResultArray: Array.isArray(payload?.result),
        hasDataArray: Array.isArray(payload?.data),
        rowCount: Array.isArray(rows) ? rows.length : 0,
        currentTableDataCount: currentTableCount
      });

      if (Array.isArray(rows)) {
        // Only update table data if:
        // 1. New data has rows (not empty), OR
        // 2. Current table is empty (initial load)
        // This prevents clearing the table when refetch returns empty data after stopping Edit Reference Stock
        if (rows.length > 0 || currentTableCount === 0) {
          setTableData(rows);
          previousTableDataRef.current = rows; // Update ref with new data
          console.log('ActivityLogsTable: Updated table data', {
            newRowCount: rows.length,
            previousRowCount: currentTableCount,
            reason: rows.length > 0 ? 'New data has rows' : 'Initial load (table was empty)'
          });
        } else {
          console.log('ActivityLogsTable: Preserving existing table data (refetch returned empty but table has data)', {
            newRowCount: rows.length,
            currentTableDataCount: currentTableCount,
            reason: 'Preventing table clear after Edit Reference Stock stop'
          });
          // Keep existing data - don't update state or ref
        }
      } else {
        console.warn('ActivityLogsTable: inventory response has no array rows; keeping existing table data');
      }
    }else if(tagsReadData?.isLoading){
      setLoadingBar(true)
    }
  }, [tagsReadData, inventoryError, setLoadingBar]);

  // Add WebSocket listeners for Check Reference Stock
  socket.on(`${WebsocketKey.ACTIVITY_LOGS_TABLE}-${logsTableData?.data?.deviceId}-${logsTableData?.data?.processId}`, (data: any) => {
    if (data?.data?.type === "process_step_update") {
      dispatch(setProcessStep({ step: data?.data?.step, message: data?.data?.message }));
    } else if (data?.data?.type === "inventory_error") {
      dispatch(setInventoryError(data?.data?.error));
    } else if (data?.data?.type === "verification_update") {
      dispatch(setVerificationProgress({ 
        verifiedTag: data?.data?.verifiedTag, 
        totalScanned: data?.data?.totalScanned 
      }));
    } else if (data?.data?.type === "unexpected_tag") {
      dispatch(setUnexpectedTag(data?.data?.epc));
    } else if (data?.data?.type === "completion") {
      dispatch(setVerificationResults(data?.data?.verificationStats));
    }
  })


  useEffect(() => {
    console.log("CHANGES", logsTableData);
  }, [logsTableData]);

  const formatTimestamp = (value: any) => {
    if (!value) return '';
    const date = moment(value);
    // Format as "21 Oct 2025, 12:08 PM"
    return date.format('DD MMM YYYY, hh:mm A');
  };

  const getTableColumns = () => {
    return [
      {
        title: "TagId",
        dataIndex: "tagId",
        className: "noPadCell",
        width: "20%",
        render: (x: any, row: any) => {
          return (
            <div>
              <span className="tableData">{x}</span>
            </div>
          );
        },
      },
      {
        title: "EPC",
        dataIndex: "epc",
        className: "leftAlignTable",
        width: "20%",
        render: (x: any, row: any) => {
          return (
            <div>
              <span className="tableData">{x}</span>
            </div>
          );
        },
      },
      {
        title: "Description",
        dataIndex: "productDescription",
        className:"activeProcessTable",
        width: "15%",
        ellipsis: {
          showTitle: false,
        },
        render: (description: any, row: any) => {
          const fullDescription = description || row?.description || '';
          return (
            <div className="d-flex align-items-center">
              <UITooltip 
                title={fullDescription} 
                placement="top"
                overlayStyle={{ maxWidth: '500px', wordWrap: 'break-word', whiteSpace: 'normal' }}
                getPopupContainer={(trigger: HTMLElement) => trigger.parentElement || document.body}
              >
                <div className="pl-10 tableData" style={{ 
                  overflow: 'hidden', 
                  textOverflow: 'ellipsis', 
                  whiteSpace: 'nowrap',
                  maxWidth: '100%'
                }}>
                  {fullDescription}
                </div>
              </UITooltip>
            </div>
          );
        },
      },
      {
        title: "Last Updated",
        dataIndex: "createdAt",
        width: "15%",
        className: "leftAlignTable",
        ellipsis: false,
        render: (field: any, row: any) => {
          return (
            <div className="d-flex align-items-center">
              <div className="tableData">{formatTimestamp(row?.createdAt)}</div>
            </div>
          );
        },
      },
    ];
  };

  // Handle inventory API failure gracefully
  const displayData = inventoryError ? [] : tableData;
  
  return (
    <>
      <div className="card-body activityTable1">
        {/* Show error message if inventory API failed */}
        {inventoryError && (
          <div style={{ 
            padding: '20px', 
            textAlign: 'center', 
            border: '1px solid #ff4d4f',
            borderRadius: '4px',
            backgroundColor: '#fff1f0',
            marginBottom: '16px'
          }}>
            <p style={{ 
              color: '#ff4d4f', 
              fontWeight: 500,
              fontSize: '14px',
              margin: 0
            }}>
              ⚠️ Unable to connect to inventory portal at this time
            </p>
            <p style={{ 
              color: '#8c8c8c', 
              fontSize: '12px',
              margin: '8px 0 0 0'
            }}>
              The process will continue with available data. Please check your connection.
            </p>
          </div>
        )}
        
        <UITable
          columns={getTableColumns()}
          data={displayData}
          pagination={{
            pageSize: 10,
            showSizeChanger: true,
            showQuickJumper: true,
            showTotal: (total: number, range: [number, number]) => `${range[0]}-${range[1]} of ${total} items`,
            pageSizeOptions: ['10', '20', '50', '100']
          }}
          scroll={{ x: 'max-content', y: 500 }}
          className="activitytable"
          locale={{
            emptyText: tableData.length === 0 && !inventoryError ? 'No data available' : inventoryError ? 'Waiting for inventory data...' : 'No data'
          }}
        />
      </div>
    </>
  );
};
